// extracted by mini-css-extract-plugin
var _1 = "category-potA7";
var _2 = "gallery-qPPR1";
var _3 = "product-ymbAM";
var _4 = "recipe-mFkzR";
var _5 = "slide-KH2HD";
export { _1 as "category", _2 as "gallery", _3 as "product", _4 as "recipe", _5 as "slide" }
